// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#e17d5b"};